import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactionRefreshFiltersIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 17,
	viewBox: "0 0 20 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.1406 15.4608C15.6676 15.1555 18.4351 12.1957 18.4351 8.5896C18.4351 4.78037 15.3471 1.69238 11.5378 1.69238C7.72861 1.69238 4.64062 4.78037 4.64062 8.5896C4.64062 8.7927 4.6494 8.99374 4.6666 9.19238H3.16193C3.14781 8.99329 3.14062 8.79228 3.14062 8.5896C3.14062 3.95194 6.90019 0.192383 11.5378 0.192383C16.1755 0.192383 19.9351 3.95194 19.9351 8.5896C19.9351 13.0246 16.4969 16.6565 12.1406 16.9655V15.4608Z",
		fill: "#F73B20"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.86867 8.60008L0.955113 5.68652L0.0644531 6.57718L2.68112 9.19385C3.33699 9.84972 4.40035 9.84972 5.05622 9.19385L7.67289 6.57718L6.78223 5.68652L3.86867 8.60008Z",
		fill: "#F73B20"
	})]
});
export default SvgTransactionRefreshFiltersIcon;
